<a class="btn btn-outline-primary mb-3" routerLink="../credit-collection">Credit collection list</a>
<!-- Search Player -->
<div class="row" *ngIf="!data.player_uuid">
    <div class="col-12 col-md-12 col-lg-8">
        <div class="page-section">
            <div class="page-section-header">
                <h2 class="page-section-title">Player Credit — Search Player</h2>
            </div>
            <div class="page-section-filters">
                <input type="text" class="form-control form-control-sm flex-fill" style="max-width:none;"
                    placeholder="Enter Player Code / Mobile / Name" #search="ngModel" [(ngModel)]="player_search" />
            </div>
            <div *ngIf="is_searching_player" class="p-3">
                <p class="text-muted mb-0" style="font-style: italic;">Searching Player ...</p>
            </div>
            <div class="page-section-body" *ngIf="!is_searching_player && players.length > 0 && !data.player_uuid">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let player of players">
                            <td class="align-middle">{{player.code}}</td>
                            <td class="align-middle">{{player.name}}</td>
                            <td class="align-middle">{{player.mobile}}</td>
                            <td class="text-end"><button class="btn btn-sm btn-outline-primary"
                                    (click)="selectPlayer(player.uuid)"><small>Select</small></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Players with outstanding credit (weekly collection worklist) -->
        <div class="page-section mt-3" *ngIf="outstanding_list && outstanding_list.length > 0">
            <div class="page-section-header">
                <h2 class="page-section-title">Players With Outstanding Credit</h2>
            </div>
            <div class="page-section-body">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Name</th>
                            <th class="text-end">Outstanding</th>
                            <th>Last Action</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let o of outstanding_list">
                            <td class="align-middle">{{o.player_code}}</td>
                            <td class="align-middle">{{o.player_name}}</td>
                            <td class="align-middle text-end fw-bold">{{o.outstanding | number:'1.2-2'}}</td>
                            <td class="align-middle">{{o.last_type}} — {{o.last_on | date: "dd-MM-yyyy HH:mm"}}</td>
                            <td class="text-end"><button class="btn btn-sm btn-outline-primary"
                                    (click)="preselectPlayer(o.player_uuid)"><small>Open</small></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Player Selected -->
<ng-container *ngIf="data.player_uuid">
    <div class="row mb-3">
        <!-- Player + balances -->
        <div class="col-md-4 col-lg-3 col-12 mb-3 mb-md-0">
            <div class="page-section mb-0">
                <div class="page-section-header">
                    <h2 class="page-section-title">Player Credit</h2>
                    <div class="page-section-actions">
                        <button class="btn btn-sm btn-warning" (click)="resetPlayer()">New Search</button>
                    </div>
                </div>
                <div class="page-section-form">
                    <div class="d-flex align-items-center gap-2 mb-3 pb-3" style="border-bottom: 1px solid #e5e7eb;">
                        <div>
                            <div class="fw-bold" style="font-size: 15px;">{{player.name}}</div>
                            <div class="text-muted" style="font-size: 12px;">{{player.code}}</div>
                        </div>
                    </div>

                    <div class="mb-2 d-flex justify-content-between">
                        <span class="text-muted" style="font-size: 13px;">Outstanding Credit</span>
                        <span class="fw-bold" [class.text-danger]="outstanding > 0">{{outstanding | number:'1.2-2'}}</span>
                    </div>
                    <div class="mb-2 d-flex justify-content-between">
                        <span class="text-muted" style="font-size: 13px;">Wallet Balance</span>
                        <span class="fw-bold">{{wallet_balance | number:'1.2-2'}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Grant -->
        <div class="col-md-4 col-lg-4 col-12 mb-3 mb-md-0">
            <div class="page-section mb-0">
                <div class="page-section-header">
                    <h2 class="page-section-title">Grant Credit</h2>
                </div>
                <div class="page-section-form">
                    <div class="mb-3">
                        <label class="form-label" style="font-size: 12px;">Credit Amount <em>*</em></label>
                        <input type="number" min="0" class="form-control" placeholder="e.g. 3000"
                            [(ngModel)]="grant.amount" />
                        <small class="text-muted">Amount is credited into the player wallet immediately and added to
                            outstanding credit.</small>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" style="font-size: 12px;">Remark</label>
                        <input type="text" class="form-control" [(ngModel)]="grant.remark" />
                    </div>
                    <button class="btn btn-primary w-100" [disabled]="is_loading" (click)="grantCredit()">Grant
                        Credit</button>
                </div>
            </div>
        </div>

        <!-- Collect Payment (partial allowed) -->
        <div class="col-md-4 col-lg-5 col-12">
            <div class="page-section mb-0">
                <div class="page-section-header">
                    <h2 class="page-section-title">Collect Payment</h2>
                </div>
                <div class="page-section-form">
                    <div class="mb-3">
                        <label class="form-label" style="font-size: 12px;">Amount Collected (cash) <em>*</em></label>
                        <input type="number" min="0" class="form-control" placeholder="e.g. 3000"
                            [(ngModel)]="collectData.amount" />
                        <small class="text-muted">Partial payment allowed — outstanding reduces by cash collected +
                            wallet deduction (no reset to 0).</small>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" style="font-size: 12px;">Deduct From Wallet (optional)</label>
                        <input type="number" min="0" class="form-control" placeholder="0"
                            [(ngModel)]="collectData.wallet_deduct" />
                        <small class="text-muted">Settle part of the outstanding using the player's wallet balance
                            (removes it from the wallet).</small>
                    </div>
                    <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="credit-fillback"
                            [(ngModel)]="collectData.fillback" />
                        <label class="form-check-label" style="font-size: 12px;" for="credit-fillback">Fill back wallet
                            with the paid amount</label>
                        <div><small class="text-muted">Re-extends the PAID cash portion as credit: wallet +paid and it
                                stays outstanding, so the player keeps playing on the settled portion.</small></div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" style="font-size: 12px;">Remark</label>
                        <input type="text" class="form-control" [(ngModel)]="collectData.remark" />
                    </div>
                    <button class="btn btn-danger w-100" [disabled]="is_loading" (click)="collectCredit()">Collect
                        Payment</button>
                </div>
            </div>
        </div>
    </div>

    <!-- History for this player -->
    <div class="page-section">
        <div class="page-section-header">
            <h2 class="page-section-title">Credit History — {{player.code}}</h2>
        </div>
        <div class="page-section-body">
            <ng-container *ngIf="history.length == 0">
                <p class="text-muted p-3 mb-0">No credit record yet.</p>
            </ng-container>
            <table class="table table-sm table-striped mb-0" style="font-size: 12px;" *ngIf="history.length > 0">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Date/Time</th>
                        <th>Type</th>
                        <th class="text-end">Amount</th>
                        <th class="text-end">Wallet Movement</th>
                        <th class="text-end">Outstanding Before</th>
                        <th class="text-end">Outstanding After</th>
                        <th>Admin</th>
                        <th>Remark</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let h of history; let i = index;">
                        <td>{{i + 1}}</td>
                        <td>{{h.create_on | date: "dd-MM-yyyy HH:mm:ss"}}</td>
                        <td><span class="badge" [class.bg-primary]="h.type == 'grant'"
                                [class.bg-danger]="h.type == 'collect'">{{h.type}}</span></td>
                        <td class="text-end">{{h.amount | number:'1.2-2'}}</td>
                        <td class="text-end">{{h.wallet_amount | number:'1.2-2'}}</td>
                        <td class="text-end">{{h.outstanding_before | number:'1.2-2'}}</td>
                        <td class="text-end">{{h.outstanding_after | number:'1.2-2'}}</td>
                        <td>{{h.admin}}</td>
                        <td>{{h.remark}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>
